import { Outlet } from 'react-router-dom';
import { AnnouncementBar } from './AnnouncementBar';
import { TopNav } from './TopNav';
import { Footer } from './Footer';

/**
 * PageShell wraps every route with the shared marketing chrome:
 * announcement bar (dismissible) → top nav → page body (Outlet) → footer.
 */
export function PageShell() {
  return (
    <div className="flex min-h-screen flex-col bg-canvas text-ink">
      <a href="#main" className="skip-link">
        Skip to main content
      </a>
      <AnnouncementBar
        message="Scrub sensitive personal info from your documents before using ChatGPT!"
        href="https://cloakling.dev"
      />
      <TopNav />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
